import { routeShouldNotBeLocalizedRegEx } from './locales/routesNotToLocalize.js';
function getCoinbaseLocalizedUrl(url, localeCode = '') {
  try {
    const coinbaseUrl = 'https://www.coinbase.com';
    const parsedUrl = new URL(url);
    if (parsedUrl.origin === coinbaseUrl) {
      return localizePath(parsedUrl?.pathname, localeCode, coinbaseUrl);
    }
    return url;
  } catch {
    return localizePath(url, localeCode);
  }
}
function localizePath(url, localeCode, baseURL) {
  const shouldLocalize = localeCode && localeCode !== 'en' && !routeShouldNotBeLocalizedRegEx.test(url);
  return shouldLocalize ? `${baseURL ?? ''}/${localeCode}${url}` : `${baseURL ?? ''}${url}`;
}
export { getCoinbaseLocalizedUrl as default };
//# sourceMappingURL=getCoinbaseLocalizedUrl.js.map
